module.exports = __webpack_public_path__ + "static/media/Hunters-Grove-Farmington.ea509093.pdf";